import { useAuth } from "./auth/AuthContext";
import { canAdministerWorkspace } from "./auth/roles";
import { useLogout } from "./auth/useLogout";
import ApplicationFrame from "./components/ApplicationFrame";
import ThemeToggle from "./components/ThemeToggle";
import { Button } from "./components/ui";

export default function AgentFrame() {
  const auth = useAuth();
  const logout = useLogout();
  const navigation = [
    {
      to: "/companies",
      label: "Companies",
      activeWhen: (pathname: string) => pathname.startsWith("/companies"),
    },
    { to: "/runs", label: "Runs" },
    ...(canAdministerWorkspace(auth)
      ? [
          {
            to: "/admin/usage",
            label: "Usage",
            activeWhen: (pathname: string) =>
              pathname.startsWith("/admin/usage"),
          },
        ]
      : []),
  ];
  return (
    <ApplicationFrame
      variant="analyst"
      brand={{
        to: "/companies",
        label: "Isara",
        title: "Isara",
      }}
      navigation={navigation}
      secondaryNavigation={[{ to: "/settings", label: "Settings" }]}
      contentClassName="analyst-workspace"
      footer={
        <>
          <ThemeToggle />
          <span>
            {auth.identity?.displayName ??
              auth.identity?.email ??
              "Duquesne workspace"}
          </span>
          {auth.configured && (
            <Button tone="quiet" onClick={logout}>
              Sign out
            </Button>
          )}
        </>
      }
    />
  );
}
